import React from 'react';

const ITEMS = ['Inteligencia Artificial', 'Método WITS', 'Productividad', 'Automatización', 'Aprende · Aplica · Automatiza'];

const TickerMarquee: React.FC = () => {
  const track = (
    <>
      {ITEMS.map((item, i) => (
        <React.Fragment key={i}>
          <span>{item}</span>
          <span className="text-gradient-mc">✦</span>
        </React.Fragment>
      ))}
    </>
  );

  return (
    <div className="relative border-y border-white/5 bg-white/[.02] py-6 overflow-hidden">
      <div className="flex w-max animate-marquee gap-6 font-display text-lg font-bold text-white/70 md:text-2xl">
        <div className="flex shrink-0 gap-6">{track}</div>
        <div className="flex shrink-0 gap-6" aria-hidden="true">
          {track}
        </div>
      </div>
    </div>
  );
};

export default TickerMarquee;
